import { ChatHistoryQuery } from './chat-history-query';
import { ChatLogQuery } from './chat-log-query';
export var endpoints = {
    chatHistoryQuery: new ChatHistoryQuery(),
    chatLogQuery: new ChatLogQuery(),
};
